<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24" height="24"
     viewBox="0 0 24 24">
  <defs>
    <path id="a"
          d="M13.292 2.118a.997.997 0 0 0 .003-1.413.999.999 0 0 0-1.413.003L7 5.59 2.118.708A.997.997 0 0 0 .705.705a.999.999 0 0 0 .003 1.413L5.59 7 .708 11.882a.997.997 0 0 0-.003 1.413.999.999 0 0 0 1.413-.003L7 8.41l4.882 4.882a.997.997 0 0 0 1.413.003.999.999 0 0 0-.003-1.413L8.41 7l4.882-4.882z"/>
  </defs>
  <g fill="none" fill-rule="evenodd">
    <path d="M0 0h24v24H0z"/>
    <path fill="#000" fill-rule="nonzero"
          d="M18.292 7.118a.997.997 0 1 0-1.41-1.41L12 10.59 7.118 5.708a.997.997 0 1 0-1.41 1.41L10.59 12l-4.882 4.882a.997.997 0 1 0 1.41 1.41L12 13.41l4.882 4.882a.997.997 0 1 0 1.41-1.41L13.41 12l4.882-4.882z"/>
    <use fill="#888EA8" transform="translate(5 5)" xlink:href="#a"/>
  </g>
</svg>

